// The pages and every parts/*/Header were written against the old REST
// (Cognito) names for the creation timestamp; the API returns `createdAt`.
export const normalizeGroup = (item) => ({
  ...item,
  creationDate: item.creationDate ?? item.createdAt,
});

export const normalizeUser = (item) => ({
  ...item,
  userCreateDate: item.userCreateDate ?? item.createdAt,
});
